import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import ClientService from '../../../repository/clientRepository/ClientRepository';
import AddEditClientModal from './AddEditClientModal';
import { ReactComponent as EditPen } from '../../../assets/icons/EditPen.svg';
import { ReactComponent as DeleteX } from '../../../assets/icons/DeleteX.svg';
import { ReactComponent as Details } from '../../../assets/icons/Details.svg';
import '../../../App.css';
import { strings } from '../../../localization/Localization';

const ClientTerm = (props) => {
  const [selectedClientForEdit, setSelectedClientForEdit] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const navigate = useNavigate();

  const openClientDetailsPage = () => {
    navigate('/client-details', {
      state: { selectedClientDetails: props.client, },
    });
  };

  const handleShowEditClientModal = () => {
    setShowEditModal(true);
  };

  const handleCloseEditClientModal = () => {
    setSelectedClientForEdit({});
    setShowEditModal(false);
  };

  const deletedSuccessfullyAlert = () => {
    Swal.fire({
      icon: 'success',
      title: strings.clientDeletedSuccessfully,
    });
  };

  const errorAlert = () => {
    swal({
      title: strings.somethingWentWrong,
      icon: 'error',
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
  };

  const deleteClient = (id) => {
    ClientService.deleteClient(id)
      .then(() => {
        deletedSuccessfullyAlert();
        props.getClients();
        props.handleClose();
      }).catch(() => {
      errorAlert();
    });
  };

  const ConfirmationDelete = (id) => {
    Swal.fire({
      title: strings.confirmationDelete,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteClient(id);
      }
    });
  };

  return (
    <>
      <AddEditClientModal showModal={showEditModal}
                          handleClose={handleCloseEditClientModal}
                          selectedClientForEdit={selectedClientForEdit}
                          getClients={props.getClients}
      />
      <tr key={props.client.id}>
        <td className={"cursor-pointer"}>{props.client.id} <Details width='30px' height='30px' onClick={openClientDetailsPage}/>
        </td>
        <td>{props.client.name}</td>
        <td>{props.client.surname}</td>
        <td>{props.client.dateOfBirth}</td>
        <td>{props.client.phoneNumber}</td>
        <td>{props.client.email}</td>
        <td>{props.client.points}</td>
        <td>{props.client.loyaltyStatus}</td>
        <td>{props.client.address}</td>
        <td>
          <span className={'d-flex'}>
            <a className={"cursor-pointer"} onClick={() => {
              setSelectedClientForEdit(props.client);
              handleShowEditClientModal();
            }}>
              <EditPen width='30px' height='30px'/>
            </a>
            <a className={"cursor-pointer"} onClick={() => ConfirmationDelete(props.client.id)}><DeleteX width='30px' height='30px'/></a>
          </span>
        </td>
      </tr>
    </>
  );
};
export default ClientTerm;